<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Bn8e4Y/tc-custom/9781646561926.jpg?1723404321489" alt="This image is the cover for the book Daimon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Daimon
      </h1>
      <p class="bookDescription body article font2">
        <p>He was a romantic and a realist, a lover of strong women and beautiful men. And though he was at one time the richest, most powerful man in the world, his most prized possession was a book -- Homer’s <i>The Iliad,</i> annotated by his tutor, Aristotle.<br/><br/>Most of all, he was as much a myth as a man and a mystery ... even to himself.<br/><br/>When Alexander the Great died in Babylon in 323 B.C. a month shy of his 33rd birthday and after conquering and reordering Persia, he left a sprawling empire and a burning question: What drove him?<br/><br/>Before Alexander, culture flowed East to West. After, it would flow West to East, and we are the heirs of the continuing tension between the two.<br/><br/>In this historical novel, Alexander encounters the only two enemies he cannot defeat: death and time. Surrendering to both, he considers a life that attempted to bridge seemingly irreconcilable opposites -- East and West, Persians and Greeks, a brutal father and a ruthless mother, a wily wife and a male soulmate. And above all, a tempered mind and ungovernable passions.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Georgette Gouveia
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?804f3074